<template>
  <div v-if="current">
    <v-row>
      <v-col cols="12" sm="2">
        <v-select 
          :items="query_targets" 
          v-model="query_target"
          item-text="text"
          item-value="ref" 
          solo dense></v-select>
      </v-col>
      <v-col cols="12" sm="3">
        <v-text-field
          label="Busca"
          v-model="query" 
          @click:append="search()" 
          append-icon="mdi-magnify" 
          v-on:keyup.enter="search()"
          solo dense
        ></v-text-field>
      </v-col>
      <v-col>
        <v-alert dense text type="info">
          {{ counter }} registros encontrados
        </v-alert>
      </v-col>
    </v-row>
    <v-simple-table>
      <thead>
        <tr>
          <th>Usuário</th>
          <th>Dispositivo</th>
          <th>NAS</th>
          <th>Início</th>
          <th>Fim</th>
          <th>Entrada</th>
          <th>Saída</th>
          <th>Duração</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.username }}</td>
          <td>
            {{ item.framedipaddress }}
          </td>
          <td>
            {{ item.nasipaddress }}
          </td>
          <td>
            {{ item.acctstarttime | formatDate }} <br />
            {{ item.acctstarttime | formatTime }}
          </td>
          <td>
            {{ item.acctstoptime | formatDate }} <br />
            {{ item.acctstoptime | formatTime }}
          </td>
          <td>{{ (item.acctinputoctets / 1024 / 1024).toFixed(3) }} MB</td>
          <td>{{ (item.acctoutputoctets / 1024 / 1024).toFixed(3) }} MB</td>
          <td>{{ item.acctsessiontime }}</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th>&nbsp;</th>
          <th>Total</th>
          <th>{{ (totalInput / 1024 / 1024).toFixed(3) }} MB</th>
          <th>{{ (totalOutput / 1024 / 1024).toFixed(3) }} MB</th>
          <th>&nbsp;</th>
        </tr>
      </tfoot>
    </v-simple-table>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
export default {
  data: () => ({
    current: [],
    counter: 0,
    query: "",
    query_target: "username",
    query_targets: [
      {ref: "username", text: "Usuário"},
      {ref: "framedipaddress", text: "IP"}
    ],
    dialog_loading: false
  }),
  computed: {
    totalInput: function () {
      if (this.current) {
        var sum = 0;
        var he;
        for (he of this.current) {
          sum += he.acctinputoctets;
        }
        return sum;
      }
      return 0;
    },
    totalOutput: function () {
      if (this.current) {
        var sum = 0;
        var he;
        for (he of this.current) {
          sum += he.acctoutputoctets;
        }
        return sum;
      }
      return 0;
    },
  },
  methods: {
    search: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/radacct/"+this.query_target+"/" + this.query, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
          me.counter = me.current.length;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          console.log(error);
          alert("Falha ao recuperar registros!");
        });
    }
  },
};
</script>